module.exports = __webpack_public_path__ + "img/characterAnime20.9596c1d3.png";